import { j as c } from "./jsx-runtime-e6RZPHeG.js";
import { memo as m } from "react";
const l = ({
  title: h,
  titleId: v,
  ...e
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": v,
    ...e,
    children: [
      h ? /* @__PURE__ */ c.jsx("title", { id: v, children: h }) : null,
      /* @__PURE__ */ c.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M746.658 326.398h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m0 128h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m0 128h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m-192-256h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m0 128h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m0 128h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m-192-256h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m0 128h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m0 128h-85.333c-11.776 0-21.333-9.557-21.333-21.333v-21.333c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v21.333c0 11.776-9.536 21.333-21.333 21.333m405.333-454.4h-512c-35.392 0-64 28.8-64 64v646.4c0 35.349 28.672 64 64 64h170.667c11.797 0 21.333-9.557 21.333-21.333V667.732c0-11.776 9.557-21.333 21.333-21.333h85.333c11.797 0 21.333 9.557 21.333 21.333v213.333c0 11.776 9.557 21.333 21.333 21.333H767.99c35.2 0 64-28.587 64-64v-646.4c0-35.2-28.8-64-64-64z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = m(l);
export {
  n as default
};
